import { compareNaturalText } from "@/lib/compare-natural-text";

export type User = {
  id: string;
  email: string;
  fullname?: string | null | undefined;
  username?: string | null | undefined;
  profilePicture?: string | null | undefined;
  superUser?: boolean | undefined;
};

export const sortUser = (
  a?: User | null | undefined,
  b?: User | null | undefined,
  desc: boolean = false,
): 0 | 1 | -1 => {
  if (!a && !b) {
    return 0;
  }

  if (!a) {
    return desc ? 1 : -1;
  }

  if (!b) {
    return desc ? -1 : 1;
  }

  const userNameA = a?.username;
  const userNameB = b?.username;

  if (!userNameA && !userNameB) {
    return 0;
  }

  if (!userNameA) {
    return desc ? 1 : -1;
  }

  if (!userNameB) {
    return desc ? -1 : 1;
  }

  const orderKey = compareNaturalText(userNameA, userNameB);

  if (desc) {
    return orderKey > 0 ? -1 : 1;
  }

  return orderKey > 0 ? 1 : -1;
};
